<template>
    <b-navbar>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <img
                    src="https://tostatronic.com/store/img/tostatronic-logo-1439308780.jpg"
                    alt="Lightweight UI components for Vue.js based on Bulma"
                >
            </b-navbar-item>
        </template>
        <template slot="start">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                Inicio
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'Products', params: { categoria: 'todo' }}">
                Productos
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/about' }">
                Contacto
            </b-navbar-item>
            <b-navbar-dropdown collapsible label="Categorias">
                <b-navbar-item tag="router-link" :to="{ name: 'Products', params: { categoria: 'arduino' }}">
                    Arduino
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'Products', params: { categoria: 'sensores' }}">
                    Sensores
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'Products', params: { categoria: 'robotica' }}">
                    Robótica
                </b-navbar-item>
                <b-navbar-item tag="router-link" :to="{ name: 'Products', params: { categoria: 'juguetes' }}">
                    Juguetes
                </b-navbar-item>
            </b-navbar-dropdown>
            <b-navbar-item tag="div">
                <b-field>
                    <b-autocomplete
                        v-model="name"
                        :data="filteredDataArray"
                        placeholder="Buscar..."
                        icon="magnify"
                        clearable
                        @select="option => selected = option"
                        field="name">
                        <template slot="empty">No se encontró nada</template>
                    </b-autocomplete>
                    <p class="control">
                        <button class="button is-primary">Search</button>
                    </p>
                </b-field>
            </b-navbar-item>
        </template>

        <template slot="end">
            
            <b-navbar-item tag="div">
                <div class="buttons">
                    <b-button class="button is-light" icon-pack="fas" icon-left="shopping-cart" tag="router-link" :to="{ path: '/cart' }">
                        {{ allItems.length }}
                    </b-button>
                    <b-button class="button is-primary" tag="router-link" :to="{ path: '/login' }">
                        <strong>Log in</strong>
                    </b-button>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    name: 'NavBar',
    data() {
        return {
            name: '',
            selected: null
        }
    },
    computed: {
        ...mapGetters(["allItems","allProducts"]),
        filteredDataArray() {
            return this.allProducts.filter((option) => {
                return option.name
                    .toString()
                    .toLowerCase()
                    .indexOf(this.name.toLowerCase()) >= 0
            })
        }
    },
    methods: {
        ...mapActions(["fetchItems","fetchProducts"]),
    },
    created() {
        this.fetchProducts()
    }
}
</script>
